export const SET_INITIAL_AD_BANNERS = 'SET_INITIAL_AD_BANNERS';
export const AD_BANNERS_LOADED = 'AD_BANNERS_LOADED';

export const SET_INITIAL_STATE_FLEXIBLE_FORM = 'SET_INITIAL_STATE_FLEXIBLE_FORM';
export const NEXT_STEP_FLEXIBLE_FORM = 'NEXT_STEP_FLEXIBLE_FORM';
export const PREV_STEP_FLEXIBLE_FORM = 'PREV_STEP_FLEXIBLE_FORM';
export const CHANGE_FIELD_FLEXIBLE_FORM = 'CHANGE_FIELD_FLEXIBLE_FORM';
export const RESET_FIELDS_FLEXIBLE_FORM = 'RESET_FIELDS_FLEXIBLE_FORM';
export const SUBMIT_FLEXIBLE_FORM_ERRORS = 'SUBMIT_FLEXIBLE_FORM_ERRORS';